import React from 'react';
import PropTypes from 'prop-types';

import { DoneButton, Container, Text, Graphic } from './MockIssuedComponent.styles';

const MockIssuedComponent = ({ selectedTask, setSelectedTask }) => {
  let actionVerb = selectedTask === 'cancelOrder' ? 'Cancellation' : 'Refund';

  const exitAction = () => {
    setSelectedTask(null);
  };

  return (
    <Container>
      <Graphic src="/images/reversed-dollar-sign.svg" />
      <Text>{actionVerb} has been requested</Text>
      <DoneButton type="button" onClick={exitAction}>
        BACK TO ACTIONS
      </DoneButton>
    </Container>
  );
};

MockIssuedComponent.propTypes = {
  selectedTask: PropTypes.string.isRequired,
  setSelectedTask: PropTypes.func.isRequired,
};

export default MockIssuedComponent;
